export interface MarketplaceSettings {
	giftcardFee?: number
}

export enum MarketplaceCode {
	SPAIN = "es-es",
	MEXICO = "es-mx"
}

export class Marketplace {
	public code: MarketplaceCode
	public giftcardFee?: number

	constructor(code: MarketplaceCode, giftcardFee?: number) {
		this.code = code
		this.giftcardFee = giftcardFee
	}

	static getMarketplaceName(code: MarketplaceCode): string {
		switch (code) {
			case MarketplaceCode.SPAIN:
				return "España"
			case MarketplaceCode.MEXICO:
				return "México"
			default:
				return code
		}
	}
}
